import { render, staticRenderFns } from "./RecursosPorCompetenciaFilter.vue?vue&type=template&id=7ee43d8a"
import script from "./RecursosPorCompetenciaFilter.vue?vue&type=script&lang=js"
export * from "./RecursosPorCompetenciaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports